import React from "react";

const CategorySelect = ({ categories, selectedCategoryIndex, handleCategorySelect }) => {
    return (
        <div className="category-select-container">
            <label htmlFor="category-select">Select Category: </label>
            <select
                id="category-select"
                value={selectedCategoryIndex !== null ? selectedCategoryIndex : ""}
                onChange={handleCategorySelect}
            >
                <option value="">--Select a Category--</option>
                {categories.map((cat, idx) => (
                    <option key={idx} value={idx}>
                        {cat.category}
                    </option>
                ))}
            </select>
        </div>
    );
};

export default CategorySelect;
